module.exports = __webpack_public_path__ + "img/苏州农商行.e2ac8e88.png";